<template>
  <div class="goback" @click="goBack">
    <i class="el-icon-arrow-left"></i>
    <span class="title">返回</span>
  </div>
</template>

<script>
export default {
  props: {
    routeName: {
      type: String
    }
  },
  methods: {
    goBack() {
      if (this.routeName) {
        this.$router.push({
          name: this.routeName
        });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.goback {
  padding: 2px 12px;
  width: 72px;
  height: 26px;
  border-radius: 2px;
  color: #464d6c;
  background-color: #ffffff;
  cursor: pointer;
  .title {
    color: #464d6c;
    font-size: 14px;
  }
  .el-icon-arrow-left {
    color: #747990;
    font-size: 14px;
  }
}
</style>


